window.saveHandler = function (config) {
    class ButtonState {
        constructor(button, config) {
            this.button = $(button);
            this.showSpinner = Boolean(config.showSpinner);
        }

        disable() {
            this.setButtonDisabled(true);
            this.insertSpinner();
        }

        enable({ delay = true } = {}) {
            delay ? setTimeout(() => this.setButtonDisabled(false), 2000) : this.setButtonDisabled(false);
        }

        setButtonDisabled(disabled) {
            this.button.prop("disabled", disabled).toggleClass("disabled-element", disabled);
            if (!disabled) this.removeSpinner();
        }

        insertSpinner() {
            if (!this.showSpinner) return;
            this.button.addClass("d-none disabled").attr("disabled", true);
            this.button.before(`<i class='zoop-gradient-icon fa-solid fa-spinner fa-spin font-size-24'></i>`);
        }

        removeSpinner() {
            if (!this.showSpinner) return;
            this.button.removeClass("d-none disabled").prev(".zoop-gradient-icon").remove();
        }
    }

    class HttpRequest {
        constructor(config, button) {
            this.config = config;
            this.button = button;
            this.buttonState = new ButtonState(button, config);
        }

        async send() {
            this.buttonState.disable();
            try {
                const response = await this.makeRequest();
                this.handleSuccess(response);
            } catch (error) {
                this.handleError(error);
            } finally {
                this.buttonState.enable();
            }
        }

        makeRequest() {
            this.removeAlerts();

            const data = this.config.data(this.button) || {};
            const { content = {}, action = {} } = data;

            return $.ajax({
                url: action.endpoint || "/",
                method: action.method || "POST",
                global: this.config.global,
                data: content,
            }).promise();
        }

        removeAlerts() {
            $(".alert-with-icon").remove();
        }

        handleSuccess(response) {
            new ResponseHandler(
                response,
                this.config.afterSuccess,
                this.buttonState,
                this.config.removeLineDatatableAfterSuccess,
            ).showAlert();
        }

        handleError(error) {
            if (error instanceof Error) console.warn("Erro de código:", error);

            handleMessageErrors(
                error,
                error.statusText || "Erro desconhecido",
                error.responseText || "",
                this.config.modal,
            );
        }
    }

    class ResponseHandler {
        constructor(response, afterSuccess, buttonState, removeLineDatatableAfterSuccess) {
            this.response = response;
            this.afterSuccess = afterSuccess;
            this.buttonState = buttonState;
            this.removeLineDatatableAfterSuccess = removeLineDatatableAfterSuccess;
        }

        showAlert() {
            Swal.fire({
                title: this.response.title || "Sucesso",
                icon: "success",
                text: this.response.message || "",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false,
            }).then(() => {
                this.afterSuccess(this.buttonState.button);
                this.redirectIfNeeded();
                this.removeLineDatatable();
            });
        }
        removeLineDatatable() {
            if (this.removeLineDatatableAfterSuccess) {
                let tr = $(this.buttonState.button).closest("tr");
                tr.remove();
            }
        }
        redirectIfNeeded() {
            if (this.response.redirect) handleMessageSuccessReloadPageIfConfirmed(this.response);
            if (this.response.refresh) location.reload();
        }
    }

    class SaveEventBinder {
        constructor(config) {
            this.config = config;
            this.bindEvent();
        }

        bindEvent() {
            $(this.config.elementMain).on(this.config.actionElement, this.config.button, (event) =>
                this.handleEvent(event),
            );
        }

        async handleEvent(event) {
            if (this.config.preventDefault) event.preventDefault();

            const button = $(event.currentTarget);
            const data = this.config.data(button) || {};
            const alertConfig = data.confirmation || {};

            if (!alertConfig.activate) {
                return this.triggerRequest(button);
            }

            const confirmation = await this.confirm(alertConfig);
            if (confirmation.isConfirmed) {
                this.triggerRequest(button);
            }
        }

        confirm(alertConfig) {
            return Swal.fire({
                title: alertConfig.message || "Tem certeza que deseja continuar?",
                icon: "warning",
                showCancelButton: true,
                reverseButtons: true,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger",
                cancelButtonClass: "btn btn-secondary",
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            });
        }

        triggerRequest(button) {
            new HttpRequest(this.config, button).send();
        }
    }

    class SaveConfigDTO {
        constructor(config) {
            this.elementMain = config.elementMain || "body";
            this.actionElement = config.actionElement || "click";
            this.modal = config.modal ? ".modal.show" : "body";
            this.preventDefault = Boolean(config.preventDefault);
            this.button = config.button;
            this.global = Boolean(config.global);
            this.showSpinner = Boolean(config.showSpinner);
            this.data = this.ensureFunction(config.data, () => ({ content: {}, action: {}, confirmation: {} }));
            this.afterSuccess = this.ensureFunction(config.afterSuccess, () => { });
            this.removeLineDatatableAfterSuccess = Boolean(config.removeLineDatatableAfterSuccess);
        }

        ensureFunction(fn, fallback) {
            return typeof fn === "function" ? fn : fallback;
        }
    }

    new SaveEventBinder(new SaveConfigDTO(config));
};
